import React from 'react';
import { Redirect } from 'react-router-dom';
import { getRollupStatusForGapType, useLocationFilters } from '~/util';

// Type assertion for TypeScript 5.x compatibility with react-router-dom v5
const RedirectComponent = Redirect as any;

export interface StateOnRedirectType {
    page: null | string;
    status: {
        risk_gaps?: number;
        foc_gaps?: number;
        quality_gaps?: number;
    };
}
interface PatientRedirectProps {
    patientId: number;
}
export function PatientRedirect({ patientId }: PatientRedirectProps) {
    const filters = useLocationFilters();
    const stateOnRedirect = React.useMemo<StateOnRedirectType>(() => {
        const state: StateOnRedirectType = {
            page: null, // When null Patient.js will default to risk_gaps
            status: {},
        };

        filters.forEach((x) => {
            // Set to rollup value if exists
            if (x[0].includes('risk_gaps.status')) {
                const status = parseInt(x[1]);
                state.page = 'risk_gaps';
                state.status.risk_gaps = getRollupStatusForGapType('risk_gaps', status) || status;
            }

            // Set to rollup value if exists
            if (x[0].includes('foc_gaps.status')) {
                const status = parseInt(x[1]);
                state.page = 'foc_gaps';
                state.status.foc_gaps = getRollupStatusForGapType('foc_gaps', status) || status;
            }

            // Set to rollup value if exists
            if (x[0].includes('quality_gaps.status')) {
                const status = parseInt(x[1]);
                state.page = 'quality_gaps';
                state.status.quality_gaps =
                    getRollupStatusForGapType('quality_gaps', status) || status;
            }
        });
        return state;
    }, [filters]);

    return (
        <RedirectComponent
            to={{
                pathname: `/patients/${patientId}`,
                state: stateOnRedirect,
            }}
        />
    );
}
